import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "./ChatButton.module.css";
import NiceModal from "@ebay/nice-modal-react";
import ChatBot from 'react-simple-chatbot';
import clsx from "clsx";
import OutsideClickDetector from "./OutsideClickDetector";
import { useDispatch } from "react-redux";
import { SearchReducer } from "shared/redux/reducers/search/SearchReducer";



function SearchButton() {
    const { width, isMobile } = useContext(BrowserDetectContext);
    const dispatch = useDispatch();

    const searchButtonClick = () => {
        if (isMobile) {
            NiceModal.show("search");
        } else {
            dispatch(SearchReducer.actions.toggleSearch())
        }

    }


    return (
        <div
            className={style.chatButton}
            style={{ transform: `translateX(${width / 3}px)` }}
            onClick={searchButtonClick}
        >
            <Center>
                <VerticalFlex>
                    <FlexChild height={"initial"}>
                        <Center>
                            <FontAwesomeIcon
                                icon={faSearch}
                                className={style.searchIcon}
                            />
                        </Center>
                    </FlexChild>
                    <FlexChild height={"initial"}>
                        <Center>
                            <P weight={700} size={12} color={"#666"}>Search</P>
                        </Center>
                    </FlexChild>
                </VerticalFlex>
            </Center>
        </div>
    );
}

export default SearchButton;